<template>
    <div class="col-lg-4 h-100 overflow-auto eventlist">
        <loading :active.sync="isLoading" :is-full-page="false"></loading>
        <ul class="m-2 p-2">
            <EventListItem v-for="event in events" :key="event._id" v-bind:event="event"></EventListItem>
        </ul>
        <button class="btn btn-info ml-3" v-on:click="onAddEvent">{{ $t('events.addevent') }}</button>
    </div>
</template>

<script>
import EventListItem from './EventListItem.vue';
import Loading from 'vue-loading-overlay';

export default {
    name: 'eventlist',
    computed: {
        events() {
            return this.$store.state.events.list;
        },
        isLoading() {
            return this.$store.state.events.loading;
        },
    },
    methods: {
        onAddEvent: function () {
            this.$router.push({ path: 'events', query: { mode: 'new' } });
        },
    },
    components: {
        EventListItem,
        Loading,
    },
};
</script>